<template>
  <div class="design-page">
    <!-- 未登录状态显示 -->
    <div v-if="!isLoggedIn" class="login-required">
      <div class="login-prompt">
        <i class="fas fa-lock"></i>
        <h3>需要登录才能使用设计工具</h3>
        <p>请先登录您的账户以访问画板设计功能</p>
        <button @click="goToLogin" class="login-btn">
          <i class="fas fa-sign-in-alt"></i>
          立即登录
        </button>
      </div>
    </div>

    <!-- 已登录状态显示 -->
    <div v-else class="design-content">
      <div class="iframe-container">
        <iframe ref="designIframe" :src="currentUrlWithToken" frameborder="0" allowfullscreen allow="clipboard-write; clipboard-read" class="design-iframe"
          @load="onIframeLoad"></iframe>
      </div>

      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p>正在加载设计工具...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/utils/request'

export default {
  name: 'DesignView',
  data() {
    return {
      // 默认设计工具URL，可配置
      // defaultDesignUrl: 'http://localhost:3001/canvas?lng=zh-CN',
      defaultDesignUrl: 'http://118.195.242.8:3000/',
      currentUrl: '',
      loading: true,
      isLoggedIn: false,
      userToken: '',
      userInfo: null
    }
  },

  computed: {
    // 带token的完整URL
    currentUrlWithToken() {
      if (!this.currentUrl || !this.userToken) {
        return this.currentUrl
      }

      const url = new URL(this.currentUrl)
      url.searchParams.set('token', this.userToken)

      // 如果有用户信息，也可以传递用户ID等
      if (this.userInfo) {
        url.searchParams.set('userId', this.userInfo.id || '')
        url.searchParams.set('username', this.userInfo.username || '')
      }

      return url.toString()
    }
  },

  mounted() {
    this.checkLoginStatus()

    this.getSelf()

    // 父页面执行
    window.addEventListener('message', function (event) {
      // 安全起见建议校验 origin，例如：
      if (event.data === 'refresh-parent') {
        location.reload();
      }
    });
  },

  methods: {
    async getSelf() {
      const response = await request('/api/auth/self')
      if (response.code != 0) {
        this.$router.push('/login')
      }
      console.log(response)
    },

    // 检查登录状态
    checkLoginStatus() {
      try {
        const token = localStorage.getItem('token')
        const userInfo = localStorage.getItem('userInfo')

        if (token) {
          this.isLoggedIn = true
          this.userToken = token

          if (userInfo) {
            this.userInfo = JSON.parse(userInfo)
          }

          // 登录状态下初始化设计工具
          this.initDesignTool()
        } else {
          this.isLoggedIn = false
          // 未登录时重定向到登录页
          this.$router.push('/login')
        }
      } catch (error) {
        console.error('检查登录状态失败:', error)
        this.isLoggedIn = false
        this.$router.push('/login')
      }
    },

    initDesignTool() {
      // 从localStorage获取保存的URL，如果没有则使用默认URL
      const savedUrl = localStorage.getItem('designToolUrl')
      this.currentUrl = savedUrl || this.defaultDesignUrl
    },

    onIframeLoad() {
      this.loading = false

      // 可以向iframe发送消息，传递更多用户信息
      this.postMessageToIframe({
        type: 'USER_INFO',
        data: {
          token: this.userToken,
          userInfo: this.userInfo,
          timestamp: Date.now()
        }
      })
    },

    // 向iframe发送消息
    postMessageToIframe(message) {
      if (this.$refs.designIframe && this.$refs.designIframe.contentWindow) {
        try {
          this.$refs.designIframe.contentWindow.postMessage(message, '*')
        } catch (error) {
          console.error('发送消息到iframe失败:', error)
        }
      }
    },

    // 跳转到登录页
    goToLogin() {
      this.$router.push({
        path: '/login',
        query: {
          redirect: '/design' // 登录成功后重定向回设计页面
        }
      })
    }
  }
}
</script>

<style scoped>
.design-page {
  display: flex;
  flex-direction: column;
  height: 86vh;
  background: #f5f5f5;
  margin-top: 20px;
}

/* 登录提示样式 */
.login-required {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-prompt {
  text-align: center;
  background: white;
  padding: 60px 40px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.login-prompt i {
  font-size: 64px;
  color: #667eea;
  margin-bottom: 24px;
}

.login-prompt h3 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.login-prompt p {
  margin: 0 0 32px 0;
  color: #666;
  font-size: 16px;
  line-height: 1.5;
}

.login-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

/* 设计内容样式 */
.design-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.iframe-container {
  flex: 1;
  position: relative;
  border-radius: 0;
  overflow: hidden;
}

.design-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  text-align: center;
  color: #666;
}

.loading-spinner i {
  font-size: 32px;
  margin-bottom: 12px;
  color: #409eff;
}

.loading-spinner p {
  margin: 0;
  font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-prompt {
    margin: 20px;
    padding: 40px 30px;
  }
}
</style>